/* eslint-disable prefer-const */
/* eslint-disable guard-for-in */
/* eslint-disable eqeqeq */
/* eslint-disable react/no-find-dom-node */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-unused-state */
/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["verifyRequired","verifyGst","verifyEmail","verifyNumber","verifyPan","verifyPhone","verifyLength"] }] */

import React from 'react';
import { connect } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import greenTick from 'assets/img/greenCheck.svg';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
/* eslint no-unused-expressions: "error" */
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
// @material-ui/icons
import Add from '@material-ui/icons/Add';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Done from '@material-ui/icons/Done';
import swal from 'sweetalert';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import Close from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Table from 'components/Table/Table.jsx';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Danger from 'components/Typography/Danger.jsx';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import CircularProgress from '@material-ui/core/CircularProgress';
import purple from '@material-ui/core/colors/purple';

import SweetAlert from 'react-bootstrap-sweetalert';
import axios from 'axios';
import uploadIcon from 'assets/icons/upload-icon.svg';
import Dropzone from 'react-dropzone';
// Firebase
import AddTruckersStyle from 'assets/jss/material-dashboard-pro-react/views/AddTruckersStyle.jsx';
import TextField from '@material-ui/core/TextField';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { Typography, Divider, styled } from '@material-ui/core';
import Popup from 'reactjs-popup';
import moment from 'moment';
import infoIcon from 'assets/img/infoIcon.svg';
import firebase from '../../config/config';
import PanFileUpload from './FileUploads/PanFileUpload';
import AdhaarFileUpload from './FileUploads/AdhaarFileUpload';
import TdsPercentage from './TdsPercentageSection/TdsPercentage';
import TruckerOverallRatingCard from './Ratings/TruckerOverallRatingCard';
import SecondaryContactsView from './SecondaryContacts/SecondaryContactsView';
import CommentSection from './Comments/CommentSection';
import TruckerNewFieldsView from './NewFieldsSection/TruckerNewFieldsView';
import TruckerTDS from './FileUploads/TruckerTDS';
import TruckerTdsNew from './FileUploads/TruckerTdsNew';
import auditLogger from '../../utils/auditLoggerToPG';
import apiCaller from '../../utils/apiCallerOutstanding';
import TruckDetailCard from './TruckFiles/TruckDetailCard';
import AdhaarBackFileUploader from './FileUploads/AdhaarBackFileUpload';
import FeatureFlagToastAlert from '../Components/FeatureFlagToastAlert';
import history from '../../history';
import IsMsmeRegistered from './FileUploads/IsMsmeRegistered';
import mapRole, { mappedCurrentActiveRole } from '../../utils/roleMapping';
import getUtils from '../../utils/getUtils';
import CancelledChequeUpload from './FileUploads/CancelledChequeUpload';
import logger from '../../utils/logger';
import {
  fileUploaderNew,
  getSignedURLNew,
} from '../../utils/fileUploadHandler';
import { TRUCK_NUMBER_REGEX } from '../../utils/regexValidator';

const contentStyle = { width: '300px' };

const deleteModalButton = {
  width: '45%',
  background: '#52BE56',
  borderRadius: 0,
  color: 'white',
  margin: '5px',
};

const cancelButton = {
  width: '45%',
  background: 'lightgray',
  borderRadius: 0,
  margin: '5px',
};

const panButton = {
  marginTop: '20px',
  marginLeft: '10px',
  height: '35px',
  width: '150px',
  borderRadius: '4px',
  border: '1px solid #8F95B2',
  background: 'transparent',
  color: '#474D66',
  fontWeight: '500',
};

const branhcesDropDown = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px',
  borderBottom: '1px solid #E0E0E0',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  width: '100%',
};

const fileUploaderStyles = {
  border: '1px dashed lightgray',
  width: '50%',
  padding: '3px',
  borderRadius: '5px',
};

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#fff',
    color: '#000',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    border: '1px solid #ccc',
  },
}));

const { REACT_APP_API_BASE_URL } = process.env;
const db = firebase.firestore();
const auditLog = firebase.functions().httpsCallable('utilities-auditLog');
const validateAndUpdateBanks = firebase
  .functions()
  .httpsCallable('truckers-validateAndUpdateBanks');
const retryBankAccount = firebase
  .functions()
  .httpsCallable('truckers-retryBankAccount');

const validateBank = firebase
  .functions()
  .httpsCallable('truckers-validateBankNew');

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="down" {...props} ref={ref} />
));

class AdminEditTrucker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      nameState: '',

      email: '',
      emailState: '',

      contactPerson: '',

      phoneNumber: '',
      phoneNumberState: '',

      gstNumber: '',
      gstNumberState: '',

      panNumber: '',
      panNumberState: '',

      isLoading: false,

      alert: null,

      accountNumber: '',
      accountNumberState: '',

      ifsc: '',
      ifscState: '',

      truckTypeState: '',
      truckNumberState: '',

      bankHolderName: '',
      bankHolderNameState: '',

      branchName: '',
      branchNameState: '',

      showDetails: false,
      componentLoading: false,

      selectedTruckerData: null,
      bankName: '',
      bankNameState: '',
      truckType: '',
      truckTypes: [],
      trucks: [],
      truckersData: [],
      trucksState: 'Please Add Truck Details',
      bankModal: false,
      truckNumber: '',
      banks: [],
      banksData: [],
      activeError: '',
      banksState: 'Please Add Bank Details',
      editBank: false,
      isBankEdit: false,

      approveAlert: false,
      fundAccountLoading: false,
      contactLoading: false,
      fundAccountSuccess: false,
      contactSuccess: false,
      razorpayError: '',
      isLoadingBank: false,
      secondaryContact: [],

      classicModal: false,
      edit: false,
      validating: false,
      panValidation: false,
      validationMessage: '',
      duplicateTrucker: false,
      validatingPhone: false,
      validationFailed: false,
      blacklisting: false,
      presentOrgs: [],
      verifiedNameAtBank: '',
      isVerifyingbank: false,
      checkedVerifiednameAtBank: false,
      bankAccountDetailsVerified: false,
      featureFlagFiles: '',

      panModal: false,
      panDetailData: {},
      showLoader: false,
      keyAccountModal: false,
      keyAccountBranches: [],
      options: [],
      selectAll: false,
      branchesLoading: false,
      BranchesConfirmationModal: false,
      searchQuery: '',
      activeBankId: '',
      truckerId: '',
      blacklist: false,
      fireStoreData: null,
      rcFile: null,
      rcUploading: false,
      fitnessFile: null,
      insuranceFile: null,
    };

    this.change = this.change.bind(this);
    this.submitTrucker = this.submitTrucker.bind(this);
    this.getAllTruckTypes = this.getAllTruckTypes.bind(this);
    this.getTruckerData = this.getTruckerData.bind(this);
    this.validateAllFields = this.validateAllFields.bind(this);
    this.validateBankFields = this.validateBankFields.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.verifyRequired = this.verifyRequired.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validPanDetails = this.validPanDetails.bind(this);
    this.handleKeyAccountBranchesChange = this.handleKeyAccountBranchesChange.bind(
      this
    );
  }

  componentDidMount() {
    this.setState({
      componentLoading: true,
    });
    const truckerId = history.location.pathname.split('/').pop();
    this.setState({ truckerId });

    this.getAllTruckTypes();
    const handleGetTruckerDetailsFireStore = async id => {
      try {
        const docRef = await db.collection('Truckers').doc(id);
        const doc = await docRef.get();
        if (doc.exists) {
          const data = doc.data();
          this.setState(
            {
              fireStoreData: data,
            },
            () => {
              this.handleGetTruckerDetails(truckerId);
            }
          );
        }
      } catch (error) {
        logger.error('Error fetching trucker data: ', error);
      }
    };

    handleGetTruckerDetailsFireStore(truckerId);
    ReactDOM.findDOMNode(this).scrollIntoView();
  }

  handleGetTruckerDetails = async id => {
    const { activeRole } = this.props;
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    try {
      const endPoint = `pipe/view-trucker-details?role=${currentActiveRole}&trucker_id=${id}`;
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const data = response?.data;
      this.setState(
        {
          selectedTruckerData: data?.trucker_details,
          componentLoading: false,
          showDetails: true,
        },
        () => {
          this.getTruckerData();
          this.auditLog(data);
        }
      );
    } catch (error) {
      logger.error('Error fetching trucker data: ', error);
    }
  };

  getTruckerData() {
    const { fireStoreData, truckerId } = this.state;
    const truckersData = [];
    const {
      company_name: name,
      poc_name: contactPerson,
      phone_number: phoneNumber,
      email,
      gst_number: gstNumber,
      pan_number: panNumber,
      truck_list: trucks,
      blacklist,
      bank_list: banks,
    } = this.state.selectedTruckerData || {};

    if (trucks && Array.isArray(trucks)) {
      trucks.forEach(truck => {
        truckersData.push({
          color: 'success',
          data: [truck.vehicle_number, truck.vehicle_type],
          truckData: truck,
        });
      });
    }
    const { classes, activeRole } = this.props;
    // banksData is only to show the Data in the table format
    let banksData = [];
    let activeBankId = '';

    db.collection('Truckers')
      .doc(truckerId)
      .collection('Banks')
      .onSnapshot(snapshot => {
        const banksFromFireStore = [];
        snapshot.forEach(doc => banksFromFireStore.push(doc.data()));
        this.setState({ banks: banksFromFireStore });
      });

    if (banks && Array.isArray(banks)) {
      banks.forEach((bank, i) => {
        const {
          cashfree_registered,
          razorpay_registered,
          account_verified,
          bank_account_active,
        } = bank;

        const showAccountNotVerified = account_verified === false;
        if (bank_account_active) activeBankId = bank.bank_id;
        banksData.push({
          color: 'success',
          data: [
            bank.bank_holder_name,
            bank.account_number,
            bank.bank_name,
            bank.ifsc,
            bank.bank_branch,
            <GridItem xs={12} sm={12} md={6}>
              <div className={classes.block}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={bank_account_active}
                      onChange={this.handleChange(bank, i)}
                      value={bank_account_active}
                      classes={{
                        switchBase: classes.switchBase,
                        checked: classes.switchChecked,
                        icon: classes.switchIcon,
                        iconChecked: classes.switchIconChecked,
                        bar: classes.switchBar,
                      }}
                      disabled={
                        blacklist ||
                        activeRole === 'partner-exec-manager' ||
                        showAccountNotVerified
                      }
                    />
                  }
                />
              </div>
            </GridItem>,
            cashfree_registered && razorpay_registered ? (
              <Done style={{ color: '#43a047 ' }} />
            ) : (
              <React.Fragment>
                {(activeRole === 'ops' ||
                  activeRole === 'admin' ||
                  activeRole === 'approval') &&
                !showAccountNotVerified ? (
                  <Button
                    size="sm"
                    color="warning"
                    className={classes.actionButton}
                    key={i}
                    disabled={blacklist}
                    onClick={() => {
                      this.retryContactAndFundAccount(bank);
                    }}
                  >
                    Retry
                  </Button>
                ) : showAccountNotVerified ? (
                  <p style={{ color: 'red' }}>Invalid Account</p>
                ) : (
                  <Close style={{ color: '#FF0000 ' }} />
                )}
              </React.Fragment>
            ),
          ],
        });
      });
    }
    this.getFeatureFlagStatus();

    this.setState({
      banksData,
      activeBankId,
      truckersData,
      name,
      contactPerson,
      phoneNumber,
      email,
      gstNumber,
      panNumber,
      trucks: fireStoreData?.trucks,
      blacklist,
    });
  }

  /**
   * will get all truck types from DB
   * @function
   */
  getAllTruckTypes() {
    getUtils('truck_type')
      .then(result => {
        this.setState({ truckTypes: result });
      })
      .catch(() => {
        this.setState({ truckTypes: [] });
      });
  }

  getFeatureFlagStatus() {
    db.collection('FeatureFlags')
      .doc('FileUploadsFeature')
      .onSnapshot(doc => {
        if (doc.exists) {
          const data = doc.data();
          this.setState({ featureFlagFiles: data?.truckerFiles });
        }
      });
  }

  auditLog = async data => {
    const userDetails = firebase.auth().currentUser;
    const { activeRole } = this.props;
    const { truckerId } = this.state;
    const truckerName = data?.trucker_details?.company_name;
    const role = mapRole(activeRole);
    const auditBody = {
      type: 'view',
      entity: 'Trucker',
      collection: 'Truckers',
      transporterViewedBy: userDetails.uid,
      email: userDetails.email,
      role: activeRole,
      message: `${userDetails.displayName} with email ${userDetails.email} and role ${activeRole} tried to view ${truckerName} Trucker with ${truckerId} as Trucker ID`,
      viewedAt: moment().format('llll'),
    };
    await auditLog(auditBody);
    const systemDetails = JSON.parse(localStorage.getItem('systemDetails'));
    const auditPayload = {
      collection: 'trucker',
      orgId: null,
      data: {},
      message: `${userDetails?.displayName} with email id ${userDetails?.email} viewed a trucker ${truckerName} `,
      systemDetails,
      type: `View Trucker`,
      role: `${this.capitalizeFirstLetter(role)}`,
      eventDateTime: new Date().toISOString(),
      source: 'office',
    };
    auditLogger(auditPayload);
  };

  handleClickOpen(modal) {
    const x = [];
    x[modal] = true;
    this.setState(x);
    this.setState({ verifiedNameAtBank: '' });
  }

  handleClickOpenModal(modal) {
    const x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleCloseModal(modal) {
    const x = [];
    x[modal] = false;
    this.setState(x);
  }

  // Handle BankAccountActive Toggle
  handleChange = (currentBank, i) => event => {
    const { classes, activeRole } = this.props;
    const { banks, banksData } = this.state;
    const { account_verified } = currentBank;
    const showAccountNotVerified = account_verified === false;
    const bankIndex = banks.findIndex(bank => {
      if (bank?.bankId) return bank.bankId === currentBank.bank_id;
      return bank.accountNumber === currentBank.account_number;
    });
    // If Bank Edit is Success (Compared with the Previous values)
    this.setState({
      isBankEdit: true,
    });
    banks[bankIndex].bankAccountActive = event.target.checked;
    const bank = {
      ...banks[bankIndex],
      account_number: banks[bankIndex].accountNumber,
      bank_name: banks[bankIndex].bankName,
      bank_branch: banks[bankIndex].bankBranchName,
      bank_holder_name: banks[bankIndex].bankHolderName,
      bank_account_active: banks[bankIndex].bankAccountActive,
      bank_id: banks[bankIndex]?.bankId,
    };
    banksData[i].data = [
      currentBank.bank_holder_name,
      currentBank.account_number,
      currentBank.bank_name,
      currentBank.ifsc,
      currentBank.bank_branch,
      <GridItem xs={12} sm={12} md={6}>
        <div className={classes.block}>
          <FormControlLabel
            control={
              <Switch
                checked={banks[bankIndex].bankAccountActive}
                onChange={this.handleChange(bank, i)}
                value={banks[bankIndex].bankAccountActive}
                classes={{
                  switchBase: classes.switchBase,
                  checked: classes.switchChecked,
                  icon: classes.switchIcon,
                  iconChecked: classes.switchIconChecked,
                  bar: classes.switchBar,
                }}
                disabled={showAccountNotVerified}
              />
            }
          />
        </div>
      </GridItem>,
      currentBank?.bank_id ? (
        currentBank?.cashfree_registered && currentBank?.razorpay_registered ? (
          <Done style={{ color: '#43a047 ' }} />
        ) : (
          <React.Fragment>
            {(activeRole === 'ops' ||
              activeRole === 'admin' ||
              activeRole === 'approval') &&
            !showAccountNotVerified ? (
              <Button
                size="sm"
                color="warning"
                className={classes.actionButton}
                key={i}
                onClick={() => {
                  this.retryContactAndFundAccount(currentBank);
                }}
              >
                Retry
              </Button>
            ) : showAccountNotVerified ? (
              <p style={{ color: 'red' }}>Invalid Account</p>
            ) : (
              <Close style={{ color: '#FF0000 ' }} />
            )}
          </React.Fragment>
        )
      ) : null,
    ];

    this.setState({
      banksData,
      banks,
    });
  };

  /**
   * closes the modal button
   * @param {*} modal
   */
  handleClose(modal) {
    const x = [];
    x[modal] = false;
    this.setState(x);
    this.setState({ editBank: false });
    if (modal === 'bankModal') {
      this.setState({
        accountNumber: '',
        ifsc: '',
        bankName: '',
        branchName: '',
        bankHolderName: '',
        accountNumberState: '',
        ifscState: '',
        bankNameState: '',
        branchNameState: '',
        bankHolderNameState: '',
        validateError: '',
      });
    }
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
    // eslint-disable-next-line react/destructuring-assignment
    const { activeRole } = this.props;
    if (
      activeRole == 'ops' ||
      activeRole == 'finance' ||
      activeRole == 'finance-payable' ||
      activeRole == 'finance-recievable' ||
      activeRole == 'finance-recon' ||
      activeRole == 'partner-exec-manager'
    ) {
      history.push(`/${activeRole}/truckers`);
    } else if (
      activeRole == 'sales' ||
      activeRole == 'traffic' ||
      activeRole == 'branch-ops'
    ) {
      history.push(`/${activeRole}/truckers/view`);
    } else {
      history.goBack();
    }
  }

  // function that returns true if value is there, false otherwise
  verifyRequired(value) {
    if (value) {
      return true;
    }
    return false;
  }

  // function that returns true if value is Valid GST, false otherwise
  verifyGst(value) {
    const gstRex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (gstRex.test(value)) {
      return true;
    }
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  verifyIfsc(value) {
    const regIfsc = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/;
    if (regIfsc.test(value)) {
      return true;
    }
    return false;
  }

  // function that returns true if value is email, false otherwise
  verifyEmail(value) {
    const emailRex = /[^\s@]+@[^\s@]+\.[^\s@]+/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  // function that verifies if value contains only numbers
  verifyNumber(value) {
    const numberRex = new RegExp('^[0-9]+$');
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  }

  // a function that verifies if the input param is alphanumeric
  verifyAlphanumeric(value) {
    const alphaRex = /^[a-zA-Z0-9]+$/;
    return alphaRex.test(value);
  }

  async validatePanNumber(pan) {
    // this.setState({ panValidation: true });

    const endPoint = 'pipe/pan-validate';
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    const body = {
      type: 'trucker',
      pan,
    };
    const response = await axios.post(
      `${REACT_APP_API_BASE_URL}${endPoint}`,
      body,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const duplicate = response?.data?.Info.pan_match;

    if (duplicate) {
      this.setState({
        panValidation: true,
        panNumberState: 'error',
        validationMessage: 'PAN Number already exists',
      });
    } else {
      this.setState({ panNumberState: 'success' });
    }
  }

  // function that verifies if value contains PanCard
  verifyPan(value) {
    const regpan = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/;
    if (regpan.test(value)) {
      this.validatePanNumber(value);
    }
    return false;
  }

  // function that verifies if value contains PanCard
  verifyPhone(value) {
    const regPhone = /^[6789]\d{9}$/;
    return regPhone.test(value);
  }

  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value === undefined) {
      return false;
    }
    return value?.length >= length;
  }

  // function that returns true if value is email, false otherwise
  verifyAlpha(value) {
    const emailRex = /^[a-zA-Z() ]+$/;
    return emailRex.test(value);
  }

  change(event, stateName, type, stateNameEqualTo, trimValue) {
    const values = trimValue ? event.target.value.trim() : event.target.value;
    switch (type) {
      case 'required':
        if (this.verifyRequired(values)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
          });
        }
        break;
      case 'email':
        if (this.verifyEmail(values)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
          });
        }
        break;
      case 'number':
        if (this.verifyNumber(values)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
          });
        }
        break;
      case 'alpha':
        if (this.verifyAlpha(values)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
          });
        }
        break;
      case 'length':
        if (this.verifyLength(values, stateNameEqualTo)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
          });
        }
        break;
      case 'pan':
        if (this.verifyPan(values)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
            validationMessage: 'Please check PAN Number',
          });
        }
        break;
      case 'phone':
        if (this.verifyPhone(values)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
          });
        }
        break;
      case 'gst':
        if (this.verifyGst(values)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
          });
        }
        break;
      case 'ifsc':
        if (this.verifyIfsc(values)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
          });
        }
        break;
      case 'alphanum':
        if (this.verifyAlphanumeric(values)) {
          this.setState({
            [`${stateName}State`]: 'success',
            [stateName]: values,
          });
        } else {
          this.setState({
            [`${stateName}State`]: 'error',
            [stateName]: values,
          });
        }
        break;
      default:
        break;
    }
  }

  // validates all required fields and returns a promise
  validateAllFields() {
    const { name, banks, trucks } = this.state;
    let error = false;
    return new Promise((resolve, reject) => {
      // Verify Name
      if (this.verifyLength(name, 1)) {
        this.setState({
          nameState: 'success',
        });
      } else {
        this.setState({
          nameState: 'error',
        });
        error = true;
      }

      if (trucks?.length > 0) {
        this.setState({ trucksState: '' });
      } else {
        this.setState({ trucksState: 'Please Add Truck Details' });

        error = true;
      }

      if (banks?.length > 0) {
        this.setState({ banksState: '' });
      } else {
        this.setState({ banksState: 'Please Add Bank Details' });

        error = true;
      }

      let numActiveBanks = 0;
      banks.forEach(bank => {
        if (bank.bankAccountActive) {
          numActiveBanks += 1;
        }
      });
      if (numActiveBanks !== 1) {
        this.setState({
          activeError: 'Exactly 1 bank must be active.',
        });
        error = true;
      } else {
        this.setState({
          activeError: '',
        });
      }

      if (!error) {
        resolve(true);
      } else {
        reject(error);
      }
    });
  }

  capitalizeFirstLetter(str) {
    // converting first letter to uppercase
    const capitalized = str.charAt(0).toUpperCase() + str.slice(1);

    return capitalized;
  }

  // When Bank Details edited or Role is not Admin Ops Go through the Approval Process
  submitPendingEditSales() {
    const { activeRole } = this.props;
    const { userDetails, systemDetails } = this.props;
    const { fireStoreData } = this.state;
    const {
      banks,
      name,
      email,
      contactPerson,
      phoneNumber,
      gstNumber,
      panNumber,
      trucks,
      truckerId,
    } = this.state;
    const user = firebase.auth().currentUser;
    const truckerEditData = {
      ...fireStoreData,
      name: name.trim(),
      email,
      contactPerson: contactPerson.trim(),
      phoneNumber,
      gstNumber,
      banks,
      panNumber,
      trucks,
      updatedBy: user.uid,
      modifiedAt: new Date(),
      editedBy: userDetails.uid,
      editedByName: userDetails.name,
    };
    Object.keys(truckerEditData).forEach(key => {
      if (truckerEditData[key] === undefined) {
        delete truckerEditData[key];
      }
    });

    const truckerRef = db.collection(`Truckers`);
    truckerRef
      .doc(truckerId)
      .update({ truckerEditData, editPending: true })
      .then(userDoc => {
        const auditBody = {
          data: {
            name,
            email,
            contactPerson,
            phoneNumber,
            gstNumber,
            panNumber,
            trucks,
            banks,
          },
          collection: 'Truckers',
          updatedBy: userDetails.uid,
          systemDetails,
          type: 'Edit Trucker',
          message: `${userDetails.email} edited Trucker with name ${name}`,
        };
        auditLog(auditBody);
        const auditPayload = {
          collection: 'trucker',
          orgId: truckerId,
          data: truckerEditData,
          message: `${userDetails?.name} with email id ${userDetails?.email} editted a trucker`,
          systemDetails,
          type: `Edit Trucker`,
          role: `${this.capitalizeFirstLetter(
            activeRole === 'branch-ops'
              ? 'branchOps'
              : activeRole.split('is')[0]
          )}`,
          eventDateTime: new Date().toISOString(),
          source: 'office',
        };
        auditLogger(auditPayload);
        this.clearForm();
        this.setState({ isLoading: false });
        // Updated Successfully
      })
      .catch(err => {
        const errorBody = {
          message: `${userDetails.email} tried to edit Trucker with name ${name} but FAILED`,
          status: 'fail',
          error: err,
          updatedBy: userDetails.uid,
          errorMessage: err.message,
          collection: 'Truckers',
          systemDetails,
        };
        auditLog(errorBody);
        const auditPayload = {
          collection: 'trucker',
          orgId: null,
          data: truckerEditData,
          message: `${userDetails?.name} with email id ${userDetails?.email} editted a trucker but failed ${err}`,
          systemDetails,
          type: `Edit Trucker`,
          role: `${this.capitalizeFirstLetter(
            activeRole === 'branch-ops'
              ? 'branchOps'
              : activeRole.split('is')[0]
          )}`,
          eventDateTime: new Date().toISOString(),
          source: 'office',
        };
        auditLogger(auditPayload);
      });
  }

  // Direct Approval for Ops But Only for Non Bank Data
  submitPendingEditOps() {
    const { userDetails, systemDetails, activeRole } = this.props;
    const { fireStoreData } = this.state;
    const {
      banks,
      name,
      email,
      contactPerson,
      phoneNumber,
      gstNumber,
      panNumber,
      trucks,
      truckerId,
    } = this.state;
    const user = firebase.auth().currentUser;
    const truckerEditData = {
      ...fireStoreData,
      banks,
      updatedBy: user.uid,
      modifiedAt: new Date(),
    };

    const truckerRef = db.collection(`Truckers`);
    truckerRef
      .doc(truckerId)
      .collection('EditLog')
      .add(truckerEditData)
      .then(userDoc => {
        const updateData = {
          name: name.trim(),
          email,
          contactPerson: contactPerson.trim(),
          phoneNumber,
          gstNumber,
          panNumber,
          trucks,
          updatedBy: user.uid,
          editedBy: userDetails.uid,
          editedByName: userDetails.name,
        };

        // Remove fields with undefined values
        Object.keys(updateData).forEach(key => {
          if (updateData[key] === undefined) {
            delete updateData[key];
          }
        });
        const truckerRef1 = db.collection(`Truckers`);
        truckerRef1
          .doc(truckerId)
          .update(updateData)
          .then(userRes => {
            validateAndUpdateBanks({
              truckerName: name,
              banks,
              truckerId,
              userDetails,
            })
              .then(() => {
                this.clearForm();
                this.setState({ isLoading: false });
              })
              .catch(err => {
                logger.log('Error', err);
                this.setState({ isLoading: false });
              });

            const auditBody = {
              data: {
                name,
                email,
                contactPerson,
                phoneNumber,
                gstNumber,
                panNumber,
                trucks,
                banks,
              },
              collection: 'Truckers',
              updatedBy: userDetails.uid,
              systemDetails,
              type: 'Edit Trucker',
              message: `${userDetails.email} edited Trucker with name ${name}`,
            };

            auditLog(auditBody);
            const auditPayload = {
              collection: 'trucker',
              orgId: truckerId,
              data: truckerEditData,
              message: `${userDetails?.name} with email id ${userDetails?.email} editted a trucker`,
              systemDetails,
              type: `Edit Trucker`,
              role: `${this.capitalizeFirstLetter(
                activeRole === 'branch-ops'
                  ? 'branchOps'
                  : activeRole.split('is')[0]
              )}`,
              eventDateTime: new Date().toISOString(),
              source: 'office',
            };
            auditLogger(auditPayload);

            // Updated Successfully
          })
          .catch(err => {
            const errorBody = {
              message: `${userDetails.email} tried to edit Trucker with name ${name} but FAILED`,
              status: 'fail',
              error: err,
              updatedBy: userDetails.uid,
              errorMessage: err.message,
              collection: 'Truckers',
              systemDetails,
            };
            auditLog(errorBody);
            const auditPayload = {
              collection: 'trucker',
              orgId: truckerId,
              data: truckerEditData,
              message: `${userDetails?.name} with email id ${userDetails?.email} editted a trucker but failed ${err}`,
              systemDetails,
              type: `Edit Trucker`,
              role: `${this.capitalizeFirstLetter(
                activeRole === 'branch-ops'
                  ? 'branchOps'
                  : activeRole.split('is')[0]
              )}`,
              eventDateTime: new Date().toISOString(),
              source: 'office',
            };
            auditLogger(auditPayload);
            this.setState({ isLoading: false });
          });
        // Updated Successfully
      });
  }

  /**
   * Submits the Trucker details to the Database
   * @function
   */
  submitTrucker() {
    const { isBankEdit } = this.state;
    const { activeRole } = this.props;
    this.setState({
      isLoading: true,
    });
    this.validateAllFields()
      .then(
        success => {
          if (success) {
            // Check if Bank Data Is Edited or Role is not Admin Ops then should go through Approval Process
            if (
              isBankEdit ||
              (activeRole !== 'ops' && activeRole !== 'approval')
            ) {
              this.submitPendingEditSales();
            } else {
              this.submitPendingEditOps();
            }
          }
        },
        err => {
          logger.log(err);
          this.setState({
            isLoading: false,
          });
        }
      )
      .catch(err => {
        logger.log(err);
        this.setState({
          isLoading: false,
        });
      });
  }

  /**
   * Will Clears ALl the State values after form submision
   * @function
   */
  clearForm() {
    const { classes } = this.props;
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: 'block', marginTop: '-100px' }}
          title="Good job!"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={`${classes.button} ${classes.success}`}
        >
          Trucker Edited Succeessfully
        </SweetAlert>
      ),
    });
    this.setState({
      name: '',
      nameState: '',
      email: '',
      emailState: '',
      contactPerson: '',
      phoneNumber: '',
      phoneNumberState: '',
      gstNumber: '',
      gstNumberState: '',
      panNumber: '',
      panNumberState: '',
      bankHolderName: '',
      banks: '',
      banksData: [],
      truckersData: [],
      isBankEdit: false,
    });
  }

  handleSimple = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // Will Get select Trucks form
  // eslint-disable-next-line react/sort-comp
  getTruckTypes() {
    const { classes } = this.props;
    const { truckType, truckTypes, truckTypeState } = this.state;
    return (
      <div>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="simple-select" className={classes.selectLabel}>
            Select Truck Type
          </InputLabel>
          <Select
            MenuProps={{ className: classes.selectMenu }}
            classes={{ select: classes.select }}
            value={truckType}
            onChange={this.handleSimple}
            inputProps={{ name: 'truckType', id: 'simple-select' }}
          >
            <MenuItem disabled classes={{ root: classes.selectMenuItem }}>
              Select Truck Type
            </MenuItem>
            {truckTypes.map((truckTypeRes, i) => (
              <MenuItem
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
                value={truckTypeRes?.label}
              >
                {truckTypeRes?.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {truckTypeState === 'error' && (
          <Danger>Please select truck type</Danger>
        )}
      </div>
    );
  }

  async uploadTruckDocument({
    file,
    fileType,
    resetState,
    closeModal = false,
    resetOnError = true,
  }) {
    if (!file) return;

    const { activeRole } = this.props;
    const { truckNumber, truckerId } = this.state;

    const body = {
      file_type: fileType,
      trucker_id: truckerId,
      truck_number: truckNumber,
      role: mappedCurrentActiveRole(activeRole),
    };

    try {
      const response = await getSignedURLNew(body, file);
      const { url: signedURL, metadata } = response?.data;

      await fileUploaderNew(signedURL, metadata, file);

      if (closeModal) {
        this.handleClose('classicModal');
      }

      this.setState({
        ...resetState,
        rcUploading: false,
      });
    } catch (e) {
      this.setState({
        rcUploading: false,
        ...(resetOnError ? resetState : {}),
      });
      if (fileType === 'truck_rc') {
        swal('Error', 'RC Upload Failed', 'Please retry RC upload', 'error');
      } else {
        swal(
          'Error',
          'Some of the uploads failed',
          'Please retry later',
          'error'
        );
      }
    }
  }

  async addTruck() {
    const {
      truckType,
      truckNumber,
      truckerId,
      rcFile,
      fitnessFile,
      insuranceFile,
    } = this.state;
    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;
    const endPoint = `pipe/trucker/add-truck`;
    const body = {
      truck_number: truckNumber,
      truck_type: truckType,
      org_id: truckerId,
    };

    try {
      await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');

      await this.uploadTruckDocument({
        file: rcFile,
        fileType: 'truck_rc',
        closeModal: true,
        resetOnError: false,
        resetState: {
          truckType: '',
          rcFile: null,
        },
      });
      swal(
        'Success',
        'Truck has been successfully sent to approval!',
        'success'
      );
      this.uploadTruckDocument({
        file: fitnessFile,
        fileType: 'truck_fitness',
        resetState: { fitnessFile: null },
      });
      this.uploadTruckDocument({
        file: insuranceFile,
        fileType: 'truck_insurance',
        resetState: {
          insuranceFile: null,
          truckNumber: '',
          truckNumberState: '',
        },
      });
      setTimeout(() => {
        this.handleGetTruckerDetails(truckerId);
      }, 1000);
    } catch (e) {
      swal('Failed!', 'Failed to add truck, Please try again!', 'error');
      logger.log('Error', e);
      this.setState({
        rcUploading: false,
      });
    }
  }

  async updateTrucks(trucks) {
    this.setState({
      rcUploading: true,
    });
    const { name, fireStoreData, truckerId } = this.state;
    const { userDetails, systemDetails, activeRole } = this.props;
    const user = firebase.auth().currentUser;
    const truckerEditData = {
      ...fireStoreData,
      trucks,
      updatedBy: user.uid,
      modifiedAt: new Date(),
    };
    const truckerRef = db.collection(`Truckers`);
    truckerRef
      .doc(truckerId)
      .collection('EditLog')
      .add(truckerEditData)
      .then(userDoc => {
        this.addTruck()
          .then(userRes => {
            const auditBody = {
              data: {
                trucks,
              },
              collection: 'Truckers',
              updatedBy: userDetails.uid,
              systemDetails,
              type: 'Edit Trucker Trucks',
              message: `${userDetails.email} edited trucks for Trucker with name ${name}`,
            };

            auditLog(auditBody);
            const auditPayload = {
              collection: 'trucker',
              orgId: truckerId,
              data: truckerEditData,
              message: `${userDetails?.name} with email id ${userDetails?.email} editted a trucker`,
              systemDetails,
              type: `Edit Trucker`,
              role: `${this.capitalizeFirstLetter(
                activeRole === 'branch-ops'
                  ? 'branchOps'
                  : activeRole.split('is')[0]
              )}`,
              eventDateTime: new Date().toISOString(),
              source: 'office',
            };
            auditLogger(auditPayload);

            // Updated Successfully
          })
          .catch(err => {
            const errorBody = {
              message: `${userDetails.email} tried to edit Trucker with name ${name} but FAILED`,
              status: 'fail',
              error: err,
              updatedBy: userDetails.uid,
              errorMessage: err.message,
              collection: 'Truckers',
              systemDetails,
            };
            auditLog(errorBody);
            const auditPayload = {
              collection: 'trucker',
              orgId: truckerId,
              data: truckerEditData,
              message: `${userDetails?.name} with email id ${userDetails?.email} editted a trucker but failed ${err}`,
              systemDetails,
              type: `Edit Trucker`,
              role: `${this.capitalizeFirstLetter(
                activeRole === 'branch-ops'
                  ? 'branchOps'
                  : activeRole.split('is')[0]
              )}`,
              eventDateTime: new Date().toISOString(),
              source: 'office',
            };
            auditLogger(auditPayload);
            this.setState({ isLoading: false });
            swal(
              'Oops!',
              'something went wrong please try agin later!',
              'error'
            );
          });
        // Updated Successfully
      });
  }

  // Add Trucks
  addTrucks() {
    const { userDetails } = this.props;
    const { trucks, truckType } = this.state;
    let { truckNumber } = this.state;
    const trucksData = [...(trucks ?? [])];
    if (this.verifyLength(truckType, 1)) {
      this.setState({ truckTypeState: '' });
    } else {
      this.setState({ truckTypeState: 'error' });
    }
    if (this.verifyLength(truckNumber, 1) && this.verifyLength(truckType, 1)) {
      this.setState({
        truckNumberState: 'success',
        truckTypeState: 'success',
      });
      trucksData.push({
        truckNumber,
        truckType,
        updatedByUid: userDetails?.uid,
        updatedByName: userDetails?.name,
        updatedAt: moment().format('llll'),
      });
      this.updateTrucks(trucksData);
    } else {
      this.setState({
        truckNumberState: 'error',
      });
    }
  }

  handleKeyAccountBranchesChange = event => {
    const { keyAccountModal } = this.state;
    this.setState({
      branchesLoading: true,
      keyAccountModal: !keyAccountModal,
    });
    this.getBranches();
  };

  getBranches = async () => {
    const { selectedTruckerData } = this.state;
    const branches = selectedTruckerData?.key_account_branches || [];
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    try {
      const endPoint = `utils/branches`;
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const data = response?.data?.Data;
      const options = data?.map(branch => ({
        label: branch,
        selected: branches?.includes(branch),
      }));

      const selectAll =
        branches?.length > 0 &&
        data?.every(branch => branches?.includes(branch));
      this.setState({ options, branchesLoading: false, selectAll });
    } catch (e) {
      logger.error(e);
    }
  };

  // Modal Window To Add The Trucks
  getSweetAlertForm() {
    const { classes } = this.props;
    const {
      classicModal,
      truckNumber,
      truckNumberState,
      blacklist,
      rcFile,
      truckType,
      rcUploading,
      fitnessFile,
      insuranceFile,
    } = this.state;

    const viewFile = file => {
      if (!file) return;
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, '_blank');
    };

    return (
      <Dialog
        fullWidth
        maxWidth="sm"
        classes={{ root: classes.center, paper: classes.modal }}
        style={{ maxWidth: '400px !important', textAlign: 'center' }}
        open={classicModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => this.handleClose('classicModal')}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <IconButton
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={() => this.handleClose('classicModal')}
          >
            <Close className={classes.modalClose} />
          </IconButton>
          <h4 className={classes.modalTitle} style={{ margin: '0px' }}>
            Add Truck Details
          </h4>
        </DialogTitle>
        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <GridContainer style={{ alignItems: 'end' }}>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Truck Number *"
                id="truck-number"
                formControlProps={{
                  fullWidth: true,
                  style: { paddingTop: '5px' },
                }}
                inputProps={{
                  onChange: event => {
                    let value = event.target.value;
                    value = value.toUpperCase();
                    value = value.replace(/[^A-Z0-9]/g, '');
                    if (value.length > 11) return;
                    this.change(
                      { target: { value } },
                      'truckNumber',
                      'alphanum',
                      '',
                      true
                    );
                  },
                  value: truckNumber,
                  onBlur: () => {
                    const isValid = TRUCK_NUMBER_REGEX.test(truckNumber);
                    this.setState({
                      truckNumberState: isValid ? 'success' : 'error',
                    });
                  },
                }}
                success={truckNumberState === 'success'}
                error={truckNumberState === 'error'}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              {this.getTruckTypes()}
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              {this.renderDocumentUpload({
                label: 'RC Card *',
                file: rcFile,
                onView: () => viewFile(rcFile),
                onDelete: () => this.setState({ rcFile: null }),
                onDrop: file => this.setState({ rcFile: file }),
                disabled: blacklist,
              })}
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              {this.renderDocumentUpload({
                label: 'Fitness Certificate',
                file: fitnessFile,
                onView: () => viewFile(fitnessFile),
                onDelete: () => this.setState({ fitnessFile: null }),
                onDrop: file => this.setState({ fitnessFile: file }),
                disabled: blacklist,
              })}
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              {this.renderDocumentUpload({
                label: 'Insurance',
                file: insuranceFile,
                onView: () => viewFile(insuranceFile),
                onDelete: () => this.setState({ insuranceFile: null }),
                onDrop: file => this.setState({ insuranceFile: file }),
                disabled: blacklist,
              })}
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          <Button
            disabled={
              !rcFile ||
              !truckNumber ||
              !truckType ||
              rcUploading ||
              truckNumberState !== 'success'
            }
            color="primary"
            onClick={() => this.addTrucks()}
          >
            Add {rcUploading && <CircularProgress size={8} />}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  /**
   * Will return the Table Component
   * @function
   */
  getTable() {
    const { classes, activeRole } = this.props;
    const {
      truckersData,
      trucksState,
      featureFlagFiles,
      blacklist,
      selectedTruckerData,
      truckerId,
    } = this.state;

    return (
      <div>
        <CardHeader style={{ marginBottom: '2px', paddingBottom: '2px' }}>
          <h4 style={{ margin: '10px' }}>Add Trucks</h4>
        </CardHeader>
        {truckersData?.length > 0 ? (
          <TruckDetailCard
            truckersData={truckersData}
            selectedTrucker={selectedTruckerData}
            activeRole={this.props.activeRole}
            userDetails={this.props.userDetails}
            featureFlagFiles={featureFlagFiles}
            refetch={() => this.handleGetTruckerDetails(truckerId)}
          />
        ) : (
          <div style={{ textAlign: 'center' }}>
            <p
              className={`${classes.textCenter} ${classes.title}`}
              style={{ textAlign: 'center', color: 'red' }}
            >
              {trucksState}
            </p>
          </div>
        )}
        <CardFooter>
          {!blacklist && activeRole !== 'partner-exec-manager' && (
            <Button
              color="info"
              onClick={() => this.handleClickOpen('classicModal')}
              className={classes.updateProfileButton}
              justIcon
            >
              <Add />
            </Button>
          )}
        </CardFooter>
      </div>
    );
  }

  // Modal Window To Add The Bank Details
  getBankDetailsForm() {
    const { classes } = this.props;
    const {
      bankModal,
      bankHolderName,
      bankHolderNameState,
      accountNumber,
      accountNumberState,
      ifsc,
      ifscState,
      bankName,
      bankNameState,
      branchName,
      branchNameState,
    } = this.state;

    return (
      <Dialog
        fullWidth
        maxWidth="sm"
        classes={{ root: classes.center, paper: classes.modal }}
        style={{ maxWidth: '400px !important', textAlign: 'center' }}
        open={bankModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => this.handleClose('bankModal')}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <IconButton
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={() => this.handleClose('bankModal')}
          >
            <Close className={classes.modalClose} />
          </IconButton>
          <h4 className={classes.modalTitle}>Add Bank Details</h4>
        </DialogTitle>
        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Bank Holder Name"
                id="bank Holder Name"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  onChange: event =>
                    this.change(event, 'bankHolderName', 'alpha'),
                  value: bankHolderName,
                }}
                success={bankHolderNameState === 'success'}
                error={bankHolderNameState === 'error'}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Account Number"
                id="account-number"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  onChange: event =>
                    this.change(event, 'accountNumber', 'alphanum', '', true),
                  type: 'alphanum',
                  value: accountNumber,
                }}
                success={accountNumberState === 'success'}
                error={accountNumberState === 'error'}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="IFSC Code"
                id="ifsc-number"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  onChange: event =>
                    this.change(event, 'ifsc', 'ifsc', '', true),
                  type: 'ifsc',
                  value: ifsc,
                }}
                success={ifscState === 'success'}
                error={ifscState === 'error'}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Bank name"
                id="bank-name"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  onChange: event =>
                    this.change(event, 'bankName', 'length', 2),
                  type: 'length',
                  value: bankName,
                }}
                success={bankNameState === 'success'}
                error={bankNameState === 'error'}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Enter your bank branch name"
                id="branch-name"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  onChange: event =>
                    this.change(event, 'branchName', 'length', 1),
                  type: 'length',
                  value: branchName,
                }}
                success={branchNameState === 'success'}
                error={branchNameState === 'error'}
              />
            </GridItem>
          </GridContainer>
          {this.state.verifiedNameAtBank && (
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                  }}
                >
                  <h4 style={{ fontWeight: 'bold' }}>Name At Bank</h4>
                  <p
                    style={{
                      color: '#2CAE76',
                      fontWeight: 'bold',
                      margin: 0,
                    }}
                  >
                    {this.state.verifiedNameAtBank}
                  </p>
                </div>
              </GridItem>
            </GridContainer>
          )}
        </DialogContent>
        <p style={{ color: 'red' }}>{this.state.validateError}</p>
        <DialogActions className={classes.modalFooter}>
          {this.state.isVerifyingbank ? (
            <CircularProgress
              // className={classes.progress}
              style={{ color: purple[500] }}
              thickness={4}
              // variant="indeterminate"
              disableShrink
            />
          ) : (
            <Button color="primary" onClick={() => this.verifyBanks()}>
              Verify
            </Button>
          )}
          {this.state.isLoadingBank ? (
            <CircularProgress
              // className={classes.progress}
              style={{ color: purple[500] }}
              thickness={4}
              // variant="indeterminate"
              disableShrink
            />
          ) : (
            <Button
              color="primary"
              disabled={!this.state.bankAccountDetailsVerified}
              onClick={() => this.addBanks()}
            >
              Add
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }

  /**
   * Will return the Bank Details Component
   * @function
   */
  getBanks() {
    const { classes, activeRole } = this.props;
    const { banksData, banksState, activeError, blacklist } = this.state;

    return (
      <Card style={{ marginBottom: '10px', marginTop: '10px' }}>
        <CardHeader style={{ paddingBottom: '2px' }}>
          <h4 style={{ margin: '0px' }}>Add Banks</h4>
        </CardHeader>
        {banksData?.length > 0 ? (
          <React.Fragment>
            <CardBody className={classes.customCardContentClass}>
              <Table
                hover
                tableHead={[
                  'Name',
                  'Account No',
                  'Bank',
                  'Ifsc',
                  'Branch',
                  'Active',
                  'Fund Account Status',
                ]}
                tableData={banksData}
              />
            </CardBody>
            <div style={{ textAlign: 'center' }}>
              <p
                className={`${classes.textCenter} ${classes.title}`}
                style={{ textAlign: 'center', color: 'red' }}
              >
                {activeError}
              </p>
            </div>
          </React.Fragment>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <p
              className={`${classes.textCenter} ${classes.title}`}
              style={{ textAlign: 'center', color: 'red' }}
            >
              {banksState}
            </p>
          </div>
        )}
        <CardFooter>
          {!blacklist && activeRole !== 'partner-exec-manager' && (
            <Button
              color="info"
              onClick={() => this.handleClickOpen('bankModal')}
              className={classes.updateProfileButton}
              justIcon
            >
              <Add />
            </Button>
          )}
        </CardFooter>
      </Card>
    );
  }

  renderDocumentUpload = ({
    label,
    file,
    onView,
    onDelete,
    onDrop,
    disabled,
  }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography>{label}</Typography>

      {file ? (
        <div>
          <Button
            variant="contained"
            color="success"
            size="sm"
            onClick={onView}
            startIcon={<VisibilityIcon />}
          >
            View
          </Button>
          <IconButton
            color="primary"
            component="span"
            size="small"
            onClick={onDelete}
          >
            <DeleteOutlineIcon color="error" />
          </IconButton>
        </div>
      ) : (
        <Dropzone
          accept="image/png,image/jpeg,application/pdf"
          maxFiles={1}
          disabled={disabled}
          onDrop={acceptedFiles => {
            if (!acceptedFiles.length) return;
            onDrop(acceptedFiles[0]);
          }}
        >
          {({ getRootProps, getInputProps, isDragActive }) => (
            <div {...getRootProps()} style={fileUploaderStyles}>
              <input {...getInputProps()} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  justifyContent: 'space-evenly',
                }}
              >
                <img src={uploadIcon} style={{ width: '24px' }} alt="icon" />
                <p style={{ margin: 0 }}>
                  {isDragActive ? 'Drop the file here ...' : 'Upload'}
                </p>
              </div>
            </div>
          )}
        </Dropzone>
      )}
    </div>
  );

  showPanDialog() {
    const { classes } = this.props;
    const { panModal, panDetailData, showLoader } = this.state;
    const isPanDetailDataEmpty =
      panDetailData?.pan_status === '' ||
      panDetailData?.pan_status === 'INVALID';

    return (
      <Dialog
        classes={{
          root: `${classes.center}`,
        }}
        fullWidth
        maxWidth="sm"
        open={panModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => this.handleCloseModal('panModal')}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <div className={classes.modalHeaderContent}>
            <h4 className={classes.modalTitle}>PAN Validation Details</h4>
          </div>
        </DialogTitle>

        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          {showLoader ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <CircularProgress />
            </div>
          ) : isPanDetailDataEmpty ? (
            <div
              style={{
                backgroundColor: '#FDE8E8',
                border: '1px solid #d32f2f',
                color: 'black',
                padding: '10px',
                borderRadius: '5px',
              }}
            >
              <img
                style={{
                  paddingRight: '10px',
                }}
                src={infoIcon}
                alt=""
              />
              Invalid! PAN number or details does not exist
            </div>
          ) : (
            <div>
              {/* Render the PAN detail data */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Verified Name</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.verifed_name}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Name on PAN</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.name_pan_card}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>DOB</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_date_of_birth}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>PAN Type</p>
                <p style={{ fontWeight: 'bold' }}>{panDetailData?.pan_type}</p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>PAN Status</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_status}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Aadhaar Linked</p>
                <p style={{ fontWeight: 'bold', color: 'green' }}>
                  {panDetailData?.pan_aadhaar_linked && (
                    <img src={greenTick} alt="icon" />
                  )}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Gender</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_gender}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>PAN Email</p>
                <p style={{ fontWeight: 'bold' }}>{panDetailData?.pan_email}</p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Address State</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_address?.city}
                  {panDetailData?.pan_address?.state}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Address Pincode</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_address?.pincode}
                </p>
              </div>
            </div>
          )}
        </DialogContent>

        <DialogActions className={classes.modalFooter}>
          <Button onClick={() => this.handleCloseModal('panModal')}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  handleSelectAll = () => {
    const { options, selectAll } = this.state;
    const updatedOptions = options?.map(option => ({
      ...option,
      selected: !selectAll,
    }));
    const selectedBranches = updatedOptions
      .filter(option => option?.selected)
      .map(option => option?.label);

    this.setState({
      options: updatedOptions,
      selectAll: !selectAll,
      keyAccountBranches: selectedBranches,
    });
  };

  handleOptionChange = label => {
    const { options } = this.state;
    const updatedOptions = options?.map(option =>
      option.label === label
        ? { ...option, selected: !option?.selected }
        : option
    );
    const selectedBranches = updatedOptions
      .filter(option => option.selected)
      .map(option => option.label);

    this.setState({
      options: updatedOptions,
      selectAll: updatedOptions?.every(option => option?.selected),
      keyAccountBranches: selectedBranches,
    });
  };

  postKeyAccountBranches = async () => {
    this.setState({
      BranchesConfirmationModal: false,
      branchesLoading: true,
    });
    const { keyAccountBranches, truckerId } = this.state;
    const { activeRole } = this.props;
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const body = {
      role: currentActiveRole,
      id: truckerId,
      type: 'trucker',
      key_account_branches: keyAccountBranches,
    };
    try {
      const endPoint = `pipe/key-account/add-branches`;
      const response = await apiCaller(
        endPoint,
        body,
        `Bearer ${token}`,
        'nh-base',
        'post'
      );
      const data = response?.data;
      this.setState({
        branchesLoading: false,
        keyAccountModal: false,
        searchQuery: '',
      });
      swal('Success!', `${data?.message}`);
      this.handleGetTruckerDetails(truckerId);
    } catch (e) {
      this.setState({ branchesLoading: false });
      swal(
        'Oops!',
        'Failed to add key Acount Branches, Please Try Again',
        'error'
      );
    }
  };

  showKeyAccountDialog() {
    const {
      options,
      selectAll,
      branchesLoading,
      BranchesConfirmationModal,
      searchQuery,
    } = this.state;

    const filteredOptions = options?.filter(option =>
      option.label.toUpperCase().includes(searchQuery.toUpperCase())
    );

    return (
      <div
        style={{
          position: 'absolute',
          left: '-200px',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '16px',
          zIndex: 1000,
          width: '275px',
        }}
      >
        {branchesLoading ? (
          <CircularProgress />
        ) : (
          <>
            <div>
              <p style={{ color: '#163BAC', fontWeight: 500 }}>
                Select the branches where Key Accounts are associated:
              </p>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <input
                type="text"
                placeholder="Search branches"
                value={searchQuery}
                onChange={e => this.setState({ searchQuery: e.target.value })}
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #E0E0E0',
                  fontSize: '14px',
                }}
              />
            </div>
            <button
              style={branhcesDropDown}
              onClick={this.handleSelectAll}
              type="button"
            >
              <input
                type="checkbox"
                checked={selectAll}
                style={{
                  marginRight: '8px',
                  accentColor: '#0039CB',
                }}
              />
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                Select all
              </span>
            </button>
            <div
              style={{
                maxHeight: '250px',
                overflowY: 'auto',
                scrollbarWidth: 'thin',
              }}
            >
              {filteredOptions && filteredOptions?.length > 0 ? (
                filteredOptions
                  .slice()
                  .sort((a, b) => a.label.localeCompare(b.label))
                  .map((option, index) => (
                    <button
                      key={`${option?.label}-${index}`}
                      style={branhcesDropDown}
                      onClick={() => this.handleOptionChange(option?.label)}
                      type="button"
                    >
                      <input
                        type="checkbox"
                        checked={option?.selected}
                        style={{
                          marginRight: '8px',
                          accentColor: '#0039CB',
                        }}
                      />
                      <span style={{ fontSize: '14px', color: '#333' }}>
                        {option?.label}
                      </span>
                    </button>
                  ))
              ) : (
                <div style={{ textAlign: 'center', color: '#666' }}>
                  No branches match your search.
                </div>
              )}
            </div>
            <div style={{ display: 'flex' }}>
              <Button
                size="sm"
                color="danger"
                fullWidth
                onClick={() => this.handleCloseModal('keyAccountModal')}
              >
                Cancel
              </Button>
              <Button
                size="sm"
                color="behance"
                fullWidth
                onClick={() =>
                  this.handleClickOpenModal('BranchesConfirmationModal')
                }
              >
                Confirm
              </Button>
            </div>
          </>
        )}
        <Dialog open={BranchesConfirmationModal} fullWidth maxWidth="xs">
          <DialogTitle>Are You Sure?</DialogTitle>
          <DialogContent>
            <p>Are you sure to proceed with the change?</p>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.handleCloseModal('BranchesConfirmationModal')}
            >
              Cancel
            </Button>
            <Button
              onClick={() => this.postKeyAccountBranches()}
              color="success"
            >
              Yes, Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  async blacklistTrucker(id) {
    const { activeRole } = this.props;
    this.setState({ blacklisting: true });
    const systemDetails = JSON.parse(localStorage.getItem('systemDetails'));
    const currentRole = mapRole(activeRole);
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    try {
      const endPoint = 'pipe/blacklist';
      const body = {
        id,
        type: 'trucker',
        role: currentActiveRole,
      };

      await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');
      const auditPayload = {
        collection: 'trucker',
        orgId: id,
        data: body,
        message: `${userDetails?.displayName} with email id ${userDetails?.email} blacklisted a trucker`,
        systemDetails,
        type: `Blacklist Trucker`,
        role: `${this.capitalizeFirstLetter(currentRole)}`,
        eventDateTime: new Date().toISOString(),
        source: 'office',
      };
      setTimeout(() => {
        this.handleGetTruckerDetails(id);
      }, 2000);

      swal(
        'Blacklisted Trucker!',
        'you have blacklisted trucker successfully!',
        'success'
      );
      this.setState({ blacklisting: false });
      auditLogger(auditPayload);
    } catch (e) {
      this.setState({ blacklisting: false });
      swal(
        'Failed!',
        'Trucker blacklist failed, Please try again later!',
        'error'
      );
    }
  }

  searchTrucker = async phone => {
    this.setState({ validatingPhone: true });
    let status = false;
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    try {
      const endPoint = `pipe/office-user-validation?phone_number=${phone}&type=phone_number_check&source=trucker`;
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const data = response?.data;
      if (data?.length > 0) {
        this.setState({ presentOrgs: data });
        status = false;
      } else {
        this.setState({ presentOrgs: data });
        status = true;
      }
      this.setState({ validatingPhone: false });
    } catch (e) {
      this.setState({ validationFailed: false });
      status = true;
      this.setState({ validatingPhone: false });
    }
    // return status;
  };

  // Will Verify Bank Details
  validateBankFields() {
    const {
      accountNumber,
      bankHolderName,
      ifsc,
      bankName,
      branchName,
    } = this.state;
    let error = false;
    return new Promise((resolve, reject) => {
      // Verify Account Number
      if (this.verifyLength(accountNumber, 5)) {
        this.setState({
          accountNumberState: 'success',
        });
      } else {
        this.setState({ accountNumberState: 'error' });
        error = true;
      }

      // Verify Account Number
      if (this.verifyAlpha(bankHolderName)) {
        this.setState({
          bankHolderNameState: 'success',
        });
      } else {
        this.setState({ bankHolderNameState: 'error' });
        error = true;
      }

      // Verify IFSC
      if (this.verifyIfsc(ifsc)) {
        this.setState({
          ifscState: 'success',
        });
      } else {
        this.setState({ ifscState: 'error' });
        error = true;
      }

      // Verify Bank Name
      if (this.verifyLength(bankName, 2)) {
        this.setState({ bankNameState: 'success' });
      } else {
        this.setState({ bankNameState: 'error' });
        error = true;
      }

      // Verify Bank Branch
      if (this.verifyLength(branchName, 2)) {
        this.setState({ branchNameState: 'success' });
      } else {
        this.setState({ branchNameState: 'error' });
        error = true;
      }

      if (!error) {
        resolve(true);
      } else {
        reject(error);
      }
    });
  }

  async checkbankDetails(data) {
    const currentUserDetails = firebase.auth().currentUser;
    const { Aa } = currentUserDetails;
    const userToken = Aa;
    const endPoint = 'pipe/bank';
    try {
      const result = await apiCaller(
        endPoint,
        data,
        `Bearer ${userToken}`,
        'pipe'
      );
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }

  verifyBanks() {
    const {
      accountNumber,
      ifsc,
      bankHolderName,
      phoneNumber,
      banks,
    } = this.state;
    const trimmedAccountNumber = accountNumber?.trim();
    const trimmedIfsc = ifsc?.trim();
    const isDuplicateBank = banks?.some(
      bank =>
        bank?.accountNumber?.trim() === trimmedAccountNumber &&
        bank?.ifsc?.trim() === trimmedIfsc
    );
    if (isDuplicateBank) {
      this.setState({
        validateError:
          'This bank account is already added. Please enter different bank details.',
      });
      return;
    }
    this.validateBankFields()
      .then(success => {
        this.setState({
          isVerifyingbank: true,
        });
        const body = {
          type: 'verify-bank',
          bank_account_name: bankHolderName?.trim(),
          bank_account_number: trimmedAccountNumber,
          ifsc_code: trimmedIfsc,
          phone_number: phoneNumber,
        };
        this.checkbankDetails(body)
          .then(result => {
            const verified = result?.data?.account_verified;
            const nameAtbank = result?.data?.name_at_bank;
            if (verified) {
              this.setState({
                verifiedNameAtBank: nameAtbank,
                isVerifyingbank: false,
                bankAccountDetailsVerified: true,
              });
            }
            //
          })
          .catch(err =>
            this.setState({
              isVerifyingbank: false,
            })
          );
      })
      .catch(err => {
        this.setState({
          isVerifyingbank: false,
        });
      });
  }

  async validPanDetails(id) {
    this.setState({
      showLoader: true,
    });
    this.handleClickOpenModal('panModal');
    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;

    const endPoint = `pipe/trucker-pan-details?trucker_id=${id}`;

    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const value = response?.data?.Data;
      this.setState({
        showLoader: false,
        panDetailData: value || {},
      });
    } catch (e) {
      logger.log('Error', e);
      this.setState({
        showLoader: false,
      });
    }
  }

  // Will Add Banks
  addBanks() {
    const { classes } = this.props;
    const {
      banks,
      banksData,
      accountNumber,
      bankName,
      ifsc,
      branchName,
      bankHolderName,
      phoneNumber,
    } = this.state;
    const bank = {
      account_number: accountNumber?.trim(),
      bank_name: bankName?.trim(),
      ifsc: ifsc?.trim(),
      bank_branch: branchName?.trim(),
      bank_holder_name: bankHolderName?.trim(),
      bank_account_active: false,
    };

    this.validateBankFields()
      .then(success => {
        this.setState({
          isLoadingBank: true,
        });
        const body = {
          account_number: accountNumber,
          ifsc_code: ifsc,
          account_name: bankHolderName?.trim(),
          phone: phoneNumber,
        };
        validateBank(body)
          .then(res => {
            if (res?.data?.data?.hasOwnProperty('all_banks')) {
              const bankData = res?.data?.data?.all_banks;
              this.setState({
                verifiedNameAtBank: bankData?.[0]?.name_at_bank,
              });
              (bankData || []).forEach(newBank => {
                if (newBank?.account_verified) {
                  this.setState({
                    isLoadingBank: false,
                    validateError: '',
                    isBankEdit: true,
                  });
                  banks.push({
                    accountNumber,
                    bankName: bankName.trim(),
                    ifsc,
                    bankBranchName: branchName.trim(),
                    bankHolderName: bankHolderName.trim(),
                    bankAccountActive: false,
                  });

                  banksData.push({
                    color: 'success',
                    data: [
                      bankHolderName,
                      accountNumber,
                      bankName,
                      ifsc,
                      branchName,
                      <GridItem xs={12} sm={12} md={6}>
                        <div className={classes.block}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={false}
                                onChange={this.handleChange(
                                  bank,
                                  banksData?.length
                                )}
                                value={false}
                                classes={{
                                  switchBase: classes.switchBase,
                                  checked: classes.switchChecked,
                                  icon: classes.switchIcon,
                                  iconChecked: classes.switchIconChecked,
                                  bar: classes.switchBar,
                                }}
                              />
                            }
                          />
                        </div>
                      </GridItem>,
                      '',
                    ],
                  });
                  this.handleClose('bankModal');
                  this.setState({
                    banksData,
                    banks,
                    accountNumber: '',
                    ifsc: '',
                    bankName: '',
                    branchName: '',
                    bankHolderName: '',
                    accountNumberState: '',
                    ifscState: '',
                    bankNameState: '',
                    branchNameState: '',
                    bankHolderNameState: '',
                  });
                } else {
                  this.setState({
                    isLoadingBank: false,
                    validateError:
                      'We are unable to validate the bank details. Please check if the bank details are correct.',
                  });
                }
              });
            }
          })
          .catch(err => {
            logger.log('Error', err);
          });
      })
      .catch(err => {
        logger.log('Error', err);
      });
  }

  retryContactAndFundAccount(bank) {
    this.setState({
      approveAlert: true,
      contactLoading: true,
      fundAccountLoading: true,
      razorpayError: '',
    });
    const { truckerId } = this.state;
    const body = {
      type: 'contact_fund_id',
      beneficiary_id: truckerId,
      account_name: bank?.bank_holder_name,
      account_number: bank?.account_number,
      ifsc_code: bank?.ifsc,
      ref_id: bank?.bank_id,
    };
    retryBankAccount(body)
      .then(res => {
        this.setState({
          contactLoading: false,
          fundAccountLoading: false,
          contactSuccess: true,
          fundAccountSuccess: true,
        });
        logger.log(res);
      })
      .catch(err => {
        this.setState({
          contactLoading: false,
          fundAccountLoading: false,
          contactSuccess: false,
          fundAccountSuccess: false,
          razorpayError: err.message,
        });
      });
  }

  checkEditChanges() {
    const {
      name,
      contactPerson,
      phoneNumber,
      email,
      gstNumber,
      panNumber,
      banks,
      selectedTruckerData,
    } = this.state;

    if (!selectedTruckerData) return false;

    const basicsChanged =
      name !== selectedTruckerData?.company_name ||
      contactPerson !== selectedTruckerData?.poc_name ||
      phoneNumber !== selectedTruckerData?.phone_number ||
      email !== selectedTruckerData?.email ||
      gstNumber !== selectedTruckerData?.gst_number ||
      panNumber !== selectedTruckerData?.pan_number;

    // Only compare length and bankAccountActive
    const banksChanged =
      banks?.length !== selectedTruckerData?.bank_list?.length ||
      banks?.some((bank, i) => {
        const original = selectedTruckerData?.bank_list?.find(
          orig => orig?.bank_id === bank?.bankId
        );
        return bank?.bankAccountActive !== original?.bank_account_active;
      });

    return basicsChanged || banksChanged;
  }

  render() {
    const { classes, activeRole, userDetails } = this.props;
    const {
      alert,
      nameState,
      name,
      contactPerson,
      phoneNumber,
      phoneNumberState,
      email,
      emailState,
      gstNumber,
      gstNumberState,
      panNumber,
      panNumberState,
      isLoading,
      approveAlert,
      contactSuccess,
      contactLoading,
      razorpayError,
      edit,
      featureFlagFiles,
      componentLoading,
      showDetails,
      activeBankId,
      truckerId,
      blacklist,
      selectedTruckerData,
    } = this.state;

    const { kyc_level, key_account_branches, tds_percentage } =
      selectedTruckerData || {};
    const splitNumber = phoneNumber?.slice(-4);
    const mask = 'xxxxx';
    const maskedNumber = mask + splitNumber;
    const isButtonDisabled =
      blacklist ||
      !(
        activeRole === 'ops' ||
        activeRole === 'approval' ||
        activeRole === 'branch-ops' ||
        activeRole === 'admin' ||
        (activeRole === 'sales' && userDetails.isSalesManager)
      );

    return (
      <div>
        {featureFlagFiles === 1 && <FeatureFlagToastAlert />}
        {componentLoading ? (
          <GridContainer justify="center">
            <CircularProgress
              className={classes.progress}
              style={{ color: purple[500] }}
              thickness={3}
            />
          </GridContainer>
        ) : (
          showDetails && (
            <GridContainer {...this.props}>
              <GridItem xs={12} sm={12} md={12}>
                {alert}
                <Card>
                  <CardHeader
                    className={`${classes.cardHeader}`}
                    color="warning"
                  >
                    <CardIcon
                      color="primary"
                      className={`${classes.cardHeader}`}
                      // eslint-disable-next-line react/destructuring-assignment
                      onClick={() => this.hideAlert()}
                    >
                      <ArrowBack />
                    </CardIcon>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <h4 className={classes.cardIconTitle}>
                        Add Trucker
                        <small />
                      </h4>
                      <div>
                        {this.state.blacklisting ? (
                          <CircularProgress />
                        ) : (activeRole === 'ops' ||
                            activeRole === 'approval') &&
                          !blacklist ? (
                          <Popup
                            trigger={
                              this.state.blacklisting ? (
                                <CircularProgress
                                  style={{ color: '#FCD21F', margin: '5px' }}
                                  size={30}
                                  thickness={8}
                                />
                              ) : (
                                <Button
                                  style={{
                                    background: 'black',
                                    color: '#FCD21F',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  Blacklist
                                </Button>
                              )
                            }
                            {...{
                              contentStyle,
                            }}
                            modal
                          >
                            {close => (
                              <div
                                style={{
                                  padding: '10px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <HighlightOffIcon
                                  fontSize="large"
                                  color="error"
                                />

                                <h4 style={{ fontWeight: 'bold' }}>
                                  Are You Sure?
                                </h4>
                                <p>
                                  If you proceed, you will not be able to
                                  recover it
                                </p>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                  }}
                                >
                                  <Button onClick={close} style={cancelButton}>
                                    No
                                  </Button>

                                  <Button
                                    onClick={() => {
                                      close();
                                      this.blacklistTrucker(truckerId);
                                    }}
                                    style={deleteModalButton}
                                  >
                                    Yes
                                  </Button>
                                </div>
                              </div>
                            )}
                          </Popup>
                        ) : null}
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <GridContainer>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        style={{
                          display: 'flex',
                          alignItems: 'baseline',
                          gap: '20px',
                        }}
                      >
                        <CustomInput
                          labelText="Trucker Name *"
                          id="username"
                          formControlProps={{ fullWidth: true }}
                          success={nameState === 'success'}
                          error={nameState === 'error'}
                          inputProps={{
                            onChange: event =>
                              this.change(event, 'name', 'length', 1),
                            type: 'text',
                            value: name,
                            readOnly:
                              activeRole === 'finance' ||
                              activeRole === 'branch-ops' ||
                              activeRole === 'sales' ||
                              activeRole === 'traffic' ||
                              activeRole === 'finance-payable' ||
                              activeRole === 'finance-recievable' ||
                              activeRole === 'finance-recon' ||
                              activeRole === 'partner-exec-manager' ||
                              blacklist,
                          }}
                        />
                        <div>
                          <Button
                            color={isButtonDisabled ? '' : 'behance'}
                            size="sm"
                            fullWidth
                            disabled={isButtonDisabled}
                            onClick={this.handleKeyAccountBranchesChange}
                          >
                            Key Account
                          </Button>
                          <div>
                            {key_account_branches?.length > 0 && (
                              <CustomTooltip
                                title={
                                  <div>
                                    {key_account_branches?.map(
                                      (branch, index) => (
                                        <div key={index}>
                                          {branch}
                                          {index <
                                            key_account_branches?.length -
                                              1 && (
                                            <hr
                                              style={{
                                                margin: '4px 0',
                                                borderColor: '#ccc',
                                                borderStyle: 'solid',
                                              }}
                                            />
                                          )}
                                        </div>
                                      )
                                    )}
                                  </div>
                                }
                              >
                                <Typography
                                  variant="caption"
                                  style={{
                                    backgroundColor: '#EEECEC',
                                    padding: '5px',
                                    whiteSpace: 'nowrap',
                                    borderRadius: '5px',
                                  }}
                                >
                                  {key_account_branches?.[0]}
                                  {key_account_branches?.length > 1 &&
                                    ` +${key_account_branches?.length -
                                      1} more`}
                                </Typography>
                              </CustomTooltip>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            position: 'relative',
                          }}
                        >
                          {this.state.keyAccountModal &&
                            this.showKeyAccountDialog()}
                        </div>
                      </GridItem>
                      {activeRole !== 'finance' &&
                        activeRole !== 'finance-payable' &&
                        activeRole !== 'finance-recievable' &&
                        activeRole !== 'finance-recon' && (
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                              labelText="Contact Person "
                              id="contact-person"
                              formControlProps={{ fullWidth: true }}
                              inputProps={{
                                onChange: event =>
                                  this.change(
                                    event,
                                    'contactPerson',
                                    'length',
                                    0
                                  ),
                                type: 'length',
                                value: contactPerson,
                                readOnly:
                                  blacklist ||
                                  activeRole === 'partner-exec-manager',
                              }}
                            />
                          </GridItem>
                        )}
                    </GridContainer>
                    {activeRole !== 'finance' &&
                      activeRole !== 'finance-payable' &&
                      activeRole !== 'finance-recievable' &&
                      activeRole !== 'finance-recon' && (
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={6}>
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              {!edit ? (
                                <CustomInput
                                  labelText="Phone Number *"
                                  id="phone-number"
                                  formControlProps={{ fullWidth: true }}
                                  inputProps={{
                                    readOnly: true,
                                    onChange: event =>
                                      this.change(
                                        event,
                                        'phoneNumber',
                                        'phone',
                                        '',
                                        true
                                      ),
                                    type: 'phone',
                                    value:
                                      activeRole == 'ops' ||
                                      activeRole == 'admin' ||
                                      activeRole === 'approval'
                                        ? phoneNumber
                                        : maskedNumber,
                                  }}
                                  success={phoneNumberState === 'success'}
                                  error={phoneNumberState === 'error'}
                                />
                              ) : (
                                <div
                                  style={{ marginTop: '20px', width: '100%' }}
                                >
                                  <TextField
                                    onChange={event => {
                                      const regex = /^[6-9][0-9]{9}$/;
                                      if (regex.test(event.target.value)) {
                                        if (event.target.value?.length === 10) {
                                          this.searchTrucker(
                                            event.target.value
                                          );
                                        }
                                        this.setState({
                                          phoneNumber: event.target.value,
                                          phoneNumberState: 'success',
                                        });
                                      } else
                                        this.setState({
                                          phoneNumberState: 'error',
                                        });
                                    }}
                                    label="Phone Number *"
                                    fullWidth
                                    error={phoneNumberState === 'error'}
                                  />
                                  {this.state.validatingPhone ? (
                                    <CircularProgress />
                                  ) : null}
                                  {this.state.presentOrgs?.length > 0 ? (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',

                                        flexWrap: 'wrap',
                                      }}
                                    >
                                      <Typography
                                        variant="caption"
                                        gutterBottom
                                        color="primary"
                                      >
                                        Org already exists with Phone Number
                                        &nbsp;
                                      </Typography>
                                      <Typography
                                        variant="caption"
                                        gutterBottom
                                        color="primary"
                                      >
                                        (
                                      </Typography>
                                      {this.state.presentOrgs?.map(
                                        (org, index) => (
                                          <Typography
                                            variant="caption"
                                            gutterBottom
                                            color="primary"
                                            style={{
                                              marginRight: '5px',
                                              textDecoration: org?.blacklist
                                                ? 'line-through'
                                                : 'none',
                                            }}
                                          >
                                            {org?.company_name},
                                          </Typography>
                                        )
                                      )}
                                      <Typography
                                        variant="caption"
                                        gutterBottom
                                        color="primary"
                                      >
                                        )
                                      </Typography>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                              {this.state.validatingPhone ? (
                                <CircularProgress />
                              ) : null}
                            </div>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                              success={emailState === 'success'}
                              error={emailState === 'error'}
                              labelText="Email address "
                              id="email-address"
                              formControlProps={{ fullWidth: true }}
                              inputProps={{
                                onChange: event =>
                                  this.change(
                                    event,
                                    'email',
                                    'email',
                                    '',
                                    true
                                  ),
                                type: 'email',
                                value: email,
                                readOnly:
                                  blacklist ||
                                  activeRole === 'partner-exec-manager',
                              }}
                            />
                          </GridItem>
                        </GridContainer>
                      )}
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="GST Number "
                          id="gst-number"
                          formControlProps={{ fullWidth: true }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, 'gstNumber', 'gst', '', true),
                            type: 'gst',
                            value: gstNumber,
                            readOnly:
                              activeRole === 'finance' ||
                              activeRole === 'finance-payable' ||
                              activeRole === 'finance-recievable' ||
                              activeRole === 'finance-recon' ||
                              activeRole === 'partner-exec-manager' ||
                              blacklist,
                          }}
                          success={gstNumberState === 'success'}
                          error={gstNumberState === 'error'}
                        />
                      </GridItem>

                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <CustomInput
                          labelText={
                            <div
                              style={{ display: 'flex', alignItmes: 'center' }}
                            >
                              <p>PAN Number *</p>
                              {this.state.panNumberState === 'error' && (
                                <Tooltip title={this.state.validationMessage}>
                                  <InfoIcon
                                    fontSize="small"
                                    style={{ marginLeft: '10px', color: 'red' }}
                                  />
                                </Tooltip>
                              )}
                            </div>
                          }
                          id="pan-number"
                          formControlProps={{ fullWidth: true }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, 'panNumber', 'pan', '', true),
                            type: 'pan',
                            value: panNumber,
                            readOnly:
                              activeRole === 'finance' ||
                              activeRole === 'branch-ops' ||
                              activeRole === 'sales' ||
                              activeRole === 'traffic' ||
                              activeRole === 'finance-payable' ||
                              activeRole === 'finance-recievable' ||
                              activeRole === 'finance-recon' ||
                              activeRole === 'partner-exec-manager' ||
                              blacklist,
                          }}
                          success={panNumberState === 'success'}
                          error={panNumberState === 'error'}
                        />
                        <Button
                          style={panButton}
                          onClick={() => this.validPanDetails(truckerId)}
                        >
                          Pan Valid Details
                        </Button>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <TdsPercentage tdsPercentage={tds_percentage} />
                      </GridItem>
                      {(activeRole === 'finance' ||
                        activeRole === 'finance-payable' ||
                        activeRole === 'finance-recievable' ||
                        activeRole === 'finance-recon') && (
                        <GridItem xs={12} sm={12} md={12}>
                          <Divider
                            style={{ marginTop: '20px', marginBottom: '20px' }}
                          />
                        </GridItem>
                      )}
                      {activeRole !== 'finance' &&
                        activeRole !== 'finance-payable' &&
                        activeRole !== 'finance-recievable' &&
                        activeRole !== 'finance-recon' && (
                          <GridItem xs={12} sm={12} md={12}>
                            <TruckerNewFieldsView
                              activeRole={this.props.activeRole}
                              selectedTruckerData={selectedTruckerData}
                              refetch={() =>
                                this.handleGetTruckerDetails(truckerId)
                              }
                            />
                          </GridItem>
                        )}
                      {activeRole !== 'finance' &&
                        activeRole !== 'finance-payable' &&
                        activeRole !== 'finance-recievable' &&
                        activeRole !== 'finance-recon' && (
                          <GridItem xs={12} sm={12} md={12}>
                            <SecondaryContactsView
                              classes={classes}
                              truckerData={selectedTruckerData}
                              activeRole={this.props.activeRole}
                              userDetails={this.props.userDetails}
                              refetch={() =>
                                this.handleGetTruckerDetails(truckerId)
                              }
                            />
                          </GridItem>
                        )}
                      {!blacklist && (
                        <>
                          <GridItem xs={12} sm={12} md={6}>
                            <PanFileUpload
                              fileDetails={selectedTruckerData?.file_details}
                              truckerId={truckerId}
                              activeRole={this.props.activeRole}
                              featureFlagFiles={featureFlagFiles}
                              refetch={() =>
                                this.handleGetTruckerDetails(truckerId)
                              }
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <AdhaarFileUpload
                              fileDetails={selectedTruckerData?.file_details}
                              truckerId={truckerId}
                              activeRole={this.props.activeRole}
                              featureFlagFiles={featureFlagFiles}
                              refetch={() =>
                                this.handleGetTruckerDetails(truckerId)
                              }
                            />
                          </GridItem>
                          {featureFlagFiles === 2 && (
                            <GridItem xs={12} sm={12} md={6}>
                              <AdhaarBackFileUploader
                                fileDetails={selectedTruckerData?.file_details}
                                truckerId={truckerId}
                                activeRole={this.props.activeRole}
                                refetch={() =>
                                  this.handleGetTruckerDetails(truckerId)
                                }
                              />
                            </GridItem>
                          )}
                          <GridItem xs={12} sm={12} md={6}>
                            <TruckerTDS
                              fileDetails={selectedTruckerData?.file_details}
                              activeRole={this.props.activeRole}
                              stylesClass={this.props}
                              truckerId={truckerId}
                              featureFlagFiles={featureFlagFiles}
                              refetch={() =>
                                this.handleGetTruckerDetails(truckerId)
                              }
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <TruckerTdsNew
                              activeRole={this.props.activeRole}
                              truckerId={truckerId}
                              featureFlagFiles={featureFlagFiles}
                              refetch={() =>
                                this.handleGetTruckerDetails(truckerId)
                              }
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CancelledChequeUpload
                              fileDetails={selectedTruckerData?.file_details}
                              truckerId={truckerId}
                              bankId={activeBankId}
                              activeRole={this.props.activeRole}
                            />
                          </GridItem>
                        </>
                      )}

                      <GridItem xs={12} sm={12} md={6}>
                        <IsMsmeRegistered
                          truckerData={selectedTruckerData}
                          activeRole={this.props.activeRole}
                          refetch={() =>
                            this.handleGetTruckerDetails(truckerId)
                          }
                        />
                      </GridItem>
                    </GridContainer>
                    <GridContainer
                      direction="row"
                      alignItems="flex-start"
                      justifyContent="space-between"
                    >
                      <GridItem xs={12} sm={12} md={6}>
                        <GridContainer direction="column">
                          {activeRole !== 'finance' &&
                            activeRole !== 'finance-payable' &&
                            activeRole !== 'finance-recievable' &&
                            activeRole !== 'finance-recon' && (
                              <GridItem xs={12} sm={12} md={12}>
                                <TruckerOverallRatingCard
                                  activeRole={this.props.activeRole}
                                  truckerData={selectedTruckerData}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CommentSection
                          truckerData={selectedTruckerData}
                          activeRole={this.props.activeRole}
                          refetch={() =>
                            this.handleGetTruckerDetails(truckerId)
                          }
                        />
                      </GridItem>
                    </GridContainer>
                    {activeRole !== 'finance' &&
                      activeRole !== 'finance-payable' &&
                      activeRole !== 'finance-recievable' &&
                      activeRole !== 'finance-recon' && (
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={12}>
                            {this.getBanks()}
                          </GridItem>
                          <GridItem xs={12} sm={12}>
                            {this.getTable()}
                          </GridItem>

                          <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={12}>
                              {this.getBankDetailsForm()}
                            </GridItem>
                          </GridContainer>

                          <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={12}>
                              {this.getSweetAlertForm()}
                            </GridItem>
                          </GridContainer>
                        </GridContainer>
                      )}
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={12}>
                        {this.showPanDialog()}
                      </GridItem>
                    </GridContainer>
                    {activeRole !== 'finance' &&
                      activeRole !== 'finance-payable' &&
                      activeRole !== 'finance-recievable' &&
                      activeRole !== 'finance-recon' &&
                      activeRole !== 'partner-exec-manager' &&
                      !blacklist &&
                      (isLoading ? (
                        <CircularProgress
                          className={classes.progress}
                          style={{ color: purple[500] }}
                          thickness={7}
                        />
                      ) : (
                        <Button
                          color="warning"
                          onClick={this.submitTrucker}
                          className={classes.updateProfileButton}
                          disabled={
                            this.state.duplicateTrucker ||
                            this.state.panNumberState === 'error' ||
                            !this.checkEditChanges()
                          }
                        >
                          Submit
                        </Button>
                      ))}
                    <Clearfix />
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
          )
        )}
        {approveAlert && (
          <SweetAlert
            confirmBtnText="Done"
            title=""
            onConfirm={() => {
              this.setState({ approveAlert: false });
            }}
            onCancel={() => {
              this.setState({ approveAlert: false });
            }}
            confirmBtnCssClass={`${this.props.classes.button} ${this.props.classes.success}`}
          >
            <h2>
              <span className={this.props.classes.rajdhaniFont}>
                PaaS Status
              </span>
            </h2>
            <GridContainer>
              <GridItem xs={12}>
                <span style={{ fontSize: 25, textAlign: 'center' }}>
                  {' '}
                  Account is being verified.
                </span>
                {contactLoading && (
                  <CircularProgress
                    className={classes.progress}
                    style={{ color: purple[500] }}
                    size={20}
                    thickness={3}
                  />
                )}
              </GridItem>

              <GridItem xs={12}>
                {contactSuccess && (
                  <p style={{ textAlign: 'center', color: '#009688' }}>
                    Will be available after verification.
                  </p>
                )}
              </GridItem>
              <GridItem xs={12}>
                <span
                  style={{
                    fontSize: 15,
                    float: 'left',
                    color: 'red',
                  }}
                >
                  {razorpayError}
                </span>
              </GridItem>
              <GridItem xs={12}>
                <span
                  style={{
                    fontSize: 15,
                    float: 'left',
                    color: 'red',
                  }}
                >
                  {razorpayError && 'Retry in Trucker Edit.'}
                </span>
              </GridItem>
            </GridContainer>
          </SweetAlert>
        )}
      </div>
    );
  }
}
AdminEditTrucker.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  activeRole: state.main.activeRole,
  userDetails: state.main.userDetails,
  systemDetails: state.main.systemDetails,
});

export default connect(mapStateToProps)(
  withStyles(AddTruckersStyle)(AdminEditTrucker)
);
